import type { PostMeta } from "~/lib/mdx";

export const BLOG_POSTS_PER_PAGE = 9;
export const BLOG_ARCHIVE_TITLE =
  "Poradnik: bezpieczeństwo elektryczne, gazowe i przeciwpożarowe";
export const BLOG_ARCHIVE_META_TITLE = `${BLOG_ARCHIVE_TITLE} - inspektomat.pl`;

export type BlogArchivePageData = {
  allPosts: PostMeta[];
  pagePosts: PostMeta[];
  currentPage: number;
  totalPages: number;
};

export function getBlogTotalPages(postCount: number) {
  return Math.max(1, Math.ceil(postCount / BLOG_POSTS_PER_PAGE));
}

export function getBlogPagePath(page: number) {
  return page <= 1 ? "/poradnik/" : `/poradnik/strona/${page}/`;
}

export function getBlogPagePosts(posts: PostMeta[], page: number) {
  const start = (page - 1) * BLOG_POSTS_PER_PAGE;
  return posts.slice(start, start + BLOG_POSTS_PER_PAGE);
}

export function getBlogArchiveLinkTags(
  baseUrl: string,
  currentPage: number,
  totalPages: number
) {
  const normalizedBaseUrl = baseUrl.replace(/\/+$/, "");
  const linkTags: { rel: "prev" | "next"; href: string }[] = [];

  if (currentPage > 1) {
    linkTags.push({
      rel: "prev",
      href: `${normalizedBaseUrl}${getBlogPagePath(currentPage - 1)}`,
    });
  }

  if (currentPage < totalPages) {
    linkTags.push({
      rel: "next",
      href: `${normalizedBaseUrl}${getBlogPagePath(currentPage + 1)}`,
    });
  }

  return linkTags;
}

export function getBlogArchivePageMetaTitle(page: number) {
  return page <= 1
    ? BLOG_ARCHIVE_META_TITLE
    : `${BLOG_ARCHIVE_TITLE} - strona ${page} - inspektomat.pl`;
}
